export const upiHandles = [
  'apl',
  'axisbank',
  'barodapay',
  'cnrb',
  'federal',
  'hdfcbank',
  'icici',
  'idfcfirstbank',
  'indus',
  'kotak',
  'okaxis',
  'okhdfcbank',
  'okicici',
  'oksbi',
  'paytm',
  'pnb',
  'rbl',
  'sbi',
  'unionbankofindia',
  'ybl',
  'yesbank',
];

export const regularData = [
  { label: 'Company Name', key: 'companyname', disabled: true },
  { label: 'Company CIN', key: 'companycin' },
  { label: 'Invoice Number', key: 'invoicenumber', disabled: true },
  { label: 'Company Address', key: 'companyaddress', disabled: true },
  { label: 'Company Logo', key: 'companylogo' },
  { label: 'Invoice Date', key: 'invoicedate', disabled: true },
  { label: 'Company Contact Number', key: 'companycontactnumber' },
  { label: 'Company Email', key: 'companyemail' },
  { label: 'Payment Mode', key: 'paymentmode' },
  { label: 'Company GSTIN', key: 'companygstin', disabled: true },
  { label: 'Company Website', key: 'companywebsite' },
  { label: 'Credit Period', key: 'creditperiod' },
  { label: 'Company PAN', key: 'companypan' },
  // { label: "Company Bank Details", key: "companybankdetails" },
  { label: 'Payment Due Date', key: 'paymentduedate' },
  { label: 'Customer Legal Name', key: 'customerlegalname', disabled: true },
  { label: 'Customer GSTIN', key: 'customergstin', disabled: true },
  { label: 'LUT/Bond Details', key: 'lutbonddetails' },
  { label: 'Customer Display Name', key: 'customerdisplayname' },
  { label: 'Place of Supply', key: 'placeofsupply' },
  { label: 'Dispatch Details', key: 'dispatchdetails' },
  {
    label: 'Customer Billing Address',
    key: 'customerbillingaddress',
    disabled: true,
  },
  { label: 'Customer Contact Person', key: 'customercontactperson' },
  { label: 'E-way Bill Details', key: 'ewaybilldetails' },
  { label: 'Customer Shipping Address', key: 'customershippingaddress' },
  { label: 'Customer Order no: & Date', key: 'customerordernoanddate' },
  { label: 'E-invoice Details', key: 'einvoicedetails' },
  // { label: "Item wise Discount", key: "ItemWiseDiscount" },
  { label: 'HSN/SA Code', key: 'hsnsacode' },
  // { label: "Show Round-off", key: "ShowRoundOff" },
  { label: 'HSN/SA Summary Table', key: 'hsnsasummarytable' },
  { label: 'Invoice Description', key: 'invoicedescription' },
];

export const compositionData = [
  { label: 'Company Name', key: 'companyname', disabled: true },
  { label: 'Company CIN', key: 'companycin' },
  { label: 'Invoice Number', key: 'invoicenumber', disabled: true },
  { label: 'Company Address', key: 'companyaddress', disabled: true },
  { label: 'Company Logo', key: 'companylogo' },
  { label: 'Invoice Date', key: 'invoicedate', disabled: true },
  { label: 'Company Contact Number', key: 'companycontactnumber' },
  { label: 'Company Email', key: 'companyemail' },
  { label: 'Payment Mode', key: 'paymentmode' },
  { label: 'Company GSTIN', key: 'companygstin', disabled: true },
  { label: 'Company Website', key: 'companywebsite' },
  { label: 'Credit Period', key: 'creditperiod' },
  { label: 'Company PAN', key: 'companypan' },
  // { label: "Company Bank Details", key: "companybankdetails" },
  { label: 'Payment Due Date', key: 'paymentduedate' },
  { label: 'Customer Legal Name', key: 'customerlegalname', disabled: true },
  { label: 'Customer GSTIN', key: 'customergstin', disabled: true },
  { label: 'LUT/Bond Details', key: 'lutbonddetails' },
  { label: 'Customer Display Name', key: 'customerdisplayname' },
  { label: 'Place of Supply', key: 'placeofsupply' },
  { label: 'Dispatch Details', key: 'dispatchdetails' },
  {
    label: 'Customer Billing Address',
    key: 'customerbillingaddress',
    disabled: true,
  },
  { label: 'Customer Contact Person', key: 'customercontactperson' },
  { label: 'E-way Bill Details', key: 'ewaybilldetails' },
  { label: 'Customer Shipping Address', key: 'customershippingaddress' },
  { label: 'Customer Order no: & Date', key: 'customerordernoanddate' },
  { label: 'E-invoice Details', key: 'einvoicedetails' },
  // { label: "Item wise Discount", key: "ItemWiseDiscount" },
  { label: 'HSN/SA Code', key: 'hsnsacode', hide: true },
  // { label: "Show Round-off", key: "ShowRoundOff" },
  { label: 'HSN/SA Summary Table', key: 'hsnsasummarytable', hide: true },
  { label: 'Invoice Description', key: 'invoicedescription' },
];

export const regularDataForUnreg = [
  { label: 'Company Name', key: 'companyname', disabled: true },
  { label: 'Company CIN', key: 'companycin' },
  { label: 'Invoice Number', key: 'invoicenumber', disabled: true },
  { label: 'Company Address', key: 'companyaddress', disabled: true },
  { label: 'Company Logo', key: 'companylogo' },
  { label: 'Invoice Date', key: 'invoicedate', disabled: true },
  { label: 'Company Contact Number', key: 'companycontactnumber' },
  { label: 'Company Email', key: 'companyemail' },
  { label: 'Payment Mode', key: 'paymentmode' },
  // { label: "Company GSTIN", key: "CompanyGSTIN", disabled: true },
  { label: 'Company Website', key: 'companywebsite' },
  { label: 'Credit Period', key: 'creditperiod' },
  { label: 'Company PAN', key: 'companypan' },
  // { label: "Company Bank Details", key: "companybankdetails" },
  { label: 'Payment Due Date', key: 'paymentduedate' },
  {
    label: 'Customer Legal Name',
    key: 'customerlegalname',
    disabled: true,
  },
  { label: 'Customer GSTIN', key: 'customergstin', disabled: true },
  { label: 'LUT/Bond Details', key: 'lutbonddetails', hide: true },
  { label: 'Customer Display Name', key: 'customerdisplayname' },
  { label: 'Place of Supply', key: 'placeofsupply' },
  { label: 'Dispatch Details', key: 'dispatchdetails' },
  {
    label: 'Customer Billing Address',
    key: 'customerbillingaddress',
    disabled: true,
  },
  { label: 'Customer Contact Person', key: 'customercontactperson' },
  { label: 'E-way Bill Details', key: 'ewaybilldetails', hide: true },
  { label: 'Customer Shipping Address', key: 'customershippingaddress' },
  { label: 'Customer Order no: & Date', key: 'customerordernoanddate' },
  { label: 'E-invoice Details', key: 'einvoicedetails', hide: true },
  { label: 'Item wise Discount', key: 'itemwisediscount', hide: true },
  { label: 'HSN/SA Code', key: 'hsnsacode', hide: true },
  { label: 'Show Round-off', key: 'showroundoff', hide: true },
  { label: 'HSN/SA Summary Table', key: 'hsnsasummarytable', hide: true },
  { label: 'Invoice Description', key: 'invoicedescription' },
];

export const pos = [
  { label: 'Company Name', key: 'companyname', disabled: true },
  { label: 'Company CIN', key: 'companycin' },
  { label: 'Invoice Number', key: 'invoicenumber', disabled: true },
  { label: 'Company Address', key: 'companyaddress', disabled: true },
  { label: 'Company Logo', key: 'companylogo' },
  { label: 'Invoice Date', key: 'invoicedate', disabled: true },
  { label: 'Company Contact Number', key: 'companycontactnumber' },
  { label: 'Company Email', key: 'companyemail' },
  { label: 'Payment Mode', key: 'paymentmode' },
  { label: 'Company GSTIN', key: 'companygstin', disabled: true },
  { label: 'Company Website', key: 'companywebsite' },
  { label: 'Company PAN', key: 'companypan' },
  { label: 'Customer Name', key: 'customername' },
  { label: 'Customer Contact Number', key: 'customercontactnumber' },
  { label: 'Item wise Discount', key: 'itemwisediscount', hide: true },
  { label: 'HSN/SA Code', key: 'hsnsacode' },
  { label: 'Show Round-off', key: 'showroundoff', hide: true },
];
